import type { Messages } from "@prop/i18n";
import type en from "../en/multiaccount";

export default {
  signal: {
    same_person: "один человек",
    same_document: "один документ KYC",
    same_device: "одно устройство",
    same_fingerprint: "один отпечаток браузера",
    same_wallet: "один кошелёк для выплат",
    same_email: "один почтовый ящик (алиас e-mail)",
    shared_ip: "одна сеть",
  },
  trader: {
    refused: "В выплате отказано: профиль связан с другим профилем, у которого есть челлендж или funded-счёт (один человек — один профиль). Запрос передан команде на проверку; покупки, торговля и сбросы работают как обычно.",
    historyReason: "мультиаккаунт",
  },
  queue: {
    refused: "Отказано — мультиаккаунт",
    live: "Связан с профилями со счетами программ: {n}",
    overridden: "Мультиаккаунт снят: {reason}",
    upheld: "Отказ подтверждён: {reason}",
    reviewTitle: "Проверка отказа",
    reasonLabel: "Письменная причина (обязательно)",
    reasonHint: "Не короче 10 символов — например, семья за одним компьютером.",
    override: "Снять и вернуть в очередь",
    uphold: "Подтвердить отказ",
    cancel: "Отмена",
    review: "Проверить",
  },
  view: {
    tab: "Мультиаккаунты",
    title: "Связанные профили",
    lead: "Профили с общим устройством, документом KYC, кошельком для выплат или почтовым ящиком — либо с общим отпечатком браузера вместе с сетью. Выплата профиля, связанного с другим, у которого есть челлендж или funded-счёт, отклоняется автоматически; сотрудники проверяют её в «Выплатах».",
    hints: "Показать и слабые связи (только сеть или только отпечаток)",
    empty: "Связанных профилей нет.",
    members: "Профили",
    pairs: "Связи",
    blocking: "блокирует выплаты",
    hint: "только подсказка",
    accounts: "Счета",
    noAccounts: "нет счетов программ",
    refused: "ждут проверки отказы: {n}",
    paid: "выплачено: {n}",
    since: "с {at}",
  },
} satisfies Messages<typeof en>;
